import { jsx as o } from "react/jsx-runtime";
import p from "clsx";
import r from "./Hint.module.css.js";
import { Popover as c } from "../Popover/Popover.js";
import { Info as l } from "../../foundations/icons/Info.js";
const x = ({
  placement: n = "auto",
  ariaLabel: a = "More information",
  width: e = 245,
  positioning: i,
  children: s,
  className: m
}) => /* @__PURE__ */ o(
  c,
  {
    withArrow: !0,
    content: s,
    placement: n,
    classNames: { content: r.content, arrow: r.arrow },
    positioning: i,
    style: { width: e },
    children: /* @__PURE__ */ o(
      "span",
      {
        "aria-label": a,
        role: "button",
        tabIndex: 0,
        className: p(r.hintButton, m),
        onClick: (t) => {
          t.stopPropagation(), t.preventDefault();
        },
        children: /* @__PURE__ */ o("span", { className: r.iconWrapper, children: /* @__PURE__ */ o(l, {}) })
      }
    )
  }
);
export {
  x as Hint
};
//# sourceMappingURL=Hint.js.map
